import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price: number, currency: string = 'CZK'): string {
  const normalizedCurrency = currency?.toUpperCase().trim() || 'CZK'
  const isValidCurrency = /^[A-Z]{3}$/.test(normalizedCurrency)
  const safeCurrency = isValidCurrency ? normalizedCurrency : 'CZK'
  
  try {
    return new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: safeCurrency,
      maximumFractionDigits: 0,
    }).format(price)
  } catch (error) {
    console.warn(`Invalid currency code: ${currency}, falling back to CZK`)
    return new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      maximumFractionDigits: 0,
    }).format(price)
  }
}

export function formatArea(area: number): string {
  return `${area} m²`
}

export function formatRooms(rooms: number): string {
  if (rooms === 1) return '1 room'
  return `${rooms} rooms`
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str
  return str.slice(0, length) + '...'
}

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout | null = null
  
  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}

export function generateId(): string {
  return Math.random().toString(36).substring(2, 9)
}

/**
 * Returns a proxied image URL through /api/img.
 * The proxy handles CDN quirks (Sreality auth params, protocol-relative URLs)
 * centrally so web, mobile, and any future client all get working image URLs.
 */
export function proxyImageUrl(url: string | undefined | null): string {
  if (!url) return ''
  return `/img?url=${encodeURIComponent(url)}`
}

